import React from "react";
import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";
import FilaAsignados from "./alumnosAsignados/FilaAsignados";

class AlumnosAsignados extends React.Component {
  renderFilas = alumnos =>
    alumnos.map(alumno => (
      <FilaAsignados
        key={alumno.key}
        alumno={alumno}
        handleRowClick={this.props.handleRowClick}
      />
    ));

  render() {
    return (
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Fecha Alta</Table.HeaderCell>
            <Table.HeaderCell>Fecha Baja</Table.HeaderCell>
            <Table.HeaderCell>Nombre</Table.HeaderCell>
            <Table.HeaderCell>Primer Apellido</Table.HeaderCell>
            <Table.HeaderCell>Segundo Apellido</Table.HeaderCell>
            <Table.HeaderCell>Edad</Table.HeaderCell>
            <Table.HeaderCell>Teléfono</Table.HeaderCell>
            <Table.HeaderCell>IBAN</Table.HeaderCell>
            {this.props.editable && <Table.HeaderCell />}
          </Table.Row>
        </Table.Header>
        <Table.Body>{this.renderFilas(this.props.datos)}</Table.Body>
      </Table>
    );
  }
}

AlumnosAsignados.defaultProps = {
  datos: [],
  editable: false
};

AlumnosAsignados.propTypes = {
  datos: PropTypes.array,
  handleRowClick: PropTypes.func,
  editable: PropTypes.bool,
  handleBorrarAlumno: PropTypes.func
};

export default AlumnosAsignados;



// WEBPACK FOOTER //
// ./src/pages/asignacionAlumnos/AlumnosAsignados.jsx